module.exports = __webpack_public_path__ + "static/media/sarthi.bf82141f.png";